import React, { forwardRef, HTMLAttributes, PropsWithChildren } from 'react'

import { bemJoin } from 'bem-join'

import './VisuallyHidden.scss'

const b = bemJoin('visually-hidden')

export const VisuallyHidden = forwardRef<
  HTMLDivElement,
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
>(({ children, ...props }, ref) => (
  <div {...props} ref={ref} className={b()}>
    {children}
  </div>
))

VisuallyHidden.displayName = 'VisuallyHidden'
